var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00006 15.1734C7.27339 15.1734 6.55339 14.96 5.98672 14.54L3.12006 12.4C2.36006 11.8334 1.76672 10.6467 1.76672 9.70669V4.74669C1.76672 3.72002 2.52006 2.62669 3.48672 2.26669L6.81339 1.02002C7.47339 0.773355 8.51339 0.773355 9.17339 1.02002L12.5001 2.26669C13.4667 2.62669 14.2201 3.72002 14.2201 4.74669V9.70002C14.2201 10.6467 13.6267 11.8267 12.8667 12.3934L10.0001 14.5334C9.44672 14.96 8.72672 15.1734 8.00006 15.1734ZM7.16672 1.96002L3.84006 3.20669C3.27339 3.42002 2.77339 4.14002 2.77339 4.75336V9.70669C2.77339 10.34 3.22006 11.2267 3.72006 11.6L6.58672 13.74C7.35339 14.3134 8.64672 14.3134 9.42006 13.74L12.2867 11.6C12.7934 11.22 13.2334 10.34 13.2334 9.70669V4.74669C13.2334 4.14002 12.7334 3.42002 12.1667 3.20002L8.84006 1.95336C8.38672 1.79336 7.61339 1.79336 7.16672 1.96002Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "31504093b669eb00dd003d259c966256.svg";
export { ForwardRef as ReactComponent };